import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Sell: FC<IIconsProps> = ({ color, size = IconScale.S }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.neutral['100'];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.76568 9.77512C7.24956 10.0009 10.3226 10.8697 12.2581 10.7751C14.1936 10.6804 16.8548 10.069 17.5 9.77512M12.2581 23C15.1613 23 20 21.8328 20 18.1509C20 15.5059 16.9355 11.3915 15.1613 10.216C15.8065 8.89348 16.9032 5.89584 16.129 4.48519C15.5359 3.4045 14.337 4.32459 13.446 5.34269C13.0463 5.79933 12.3413 5.88224 11.8414 5.53817C10.7503 4.78714 9.26472 4.12644 8.38711 4.926C7.22582 5.984 8.87098 8.89348 9.83872 10.216C8.22582 11.6854 5 15.3296 5 18.1509C5 20.9722 9.35485 23 12.2581 23Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Sell;
